/* eslint-disable @typescript-eslint/no-unused-vars */
// © 2015-2021 WDNA - All Rights Reserved
/* IMPORT STYLES */
import '../assets/css/less/entropy_skin_dark.less';
import '../assets/css/less/entropy_skin_light.less';
import '../assets/css/less/entropy_skin_pink.less';
import '../assets/css/less/entropy_skin_gold.less';

import 'core-js';
import 'regenerator-runtime/runtime.js';
import 'jquery-ui-npm/jquery-ui.min.js';

import * as React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import { setConfig, cold } from 'react-hot-loader';

import axios from 'axios';
import jquery from 'jquery';
import moment from 'moment';
import { getStr } from 'wdna-components/lib/helpers/text';

import App from './app';
import history from './store/history';
import store from './store/configure';

import Auth from './services/auth/Auth';
import api from './services/api/Connect';
import { updateUserInfo } from './services/user/actions';

require('bootstrap');

setConfig({
  pureRender: true,
  onComponentRegister: (type: any, name: string, file: string): any => file.indexOf('node_modules') > 0 && cold(type),
  onComponentCreate: (type: any, name: string): any => name.indexOf('styled') > 0 && cold(type),
});

const Log = (message: any, component: any, crash: any): void => {
  console.error(message);
};

/* Global Constants */
window.QUERYING_DELAY = 2000;
window.GLOBAL_LOADER_FADEOUT = 1500;

/* Library */
window.getStr = getStr;
window.axios = axios;
window.$ = jquery;
window.moment = moment;

/* Services */
window.api = api;
window.store = store;
window.Logger = Log;
window.AuthService = Auth;
window.CancelToken = axios.CancelToken;
window.source = axios.CancelToken.source();

// Functions to share login info between tabs and remove on close browser
window.onload = (e: Event): void => {
  Auth.chkAuthFront(true);
};
window.onbeforeunload = (e: BeforeUnloadEvent): void => {
  Auth.chkAuthFront(false);
};

const ELEMENT_TO_BOOTSTRAP: string = 'wdna-root';
const BootstrapedElement: HTMLElement | null = document.getElementById(ELEMENT_TO_BOOTSTRAP);

const render = (): void => {
  ReactDOM.render(
    <Provider store={store}>
      <App history={history} />
    </Provider>,
    BootstrapedElement
  );
};

if (Auth.isUserAuthenticated()) {
  updateUserInfo(Auth.getUser()).catch((reason: any) => { /* pass */ });
} else {
  history.replace('/login');
}

render();

export default hot(render);
